import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from '../components/layout/public/Topbar';
import Footer from '../components/layout/public/Footer';

const PublicLayout = () => {
    return (
        <div className="min-h-screen flex flex-col bg-[#222629] text-white">
            <Topbar />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default PublicLayout;